import { annualReport } from './annual_report';
import { collections } from './collections';

export const sliceReducers = {
  annualReport,
  collections,
};
